<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('evaluationQuestion') }}</h2>
				<ja-button
					v-if="showCreate"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table Question -->
			<ja-evaluation-question-table
				v-if="showCreate && dataTableEvaluation"
				:data="dataTableEvaluation"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-evaluation-question-table>
			<!-- Create evaluation question -->
			<ja-evaluation-question-create-new
				v-if="!showCreate"
				:data-edit="dataEdit"
				@saveQuestion="handleSaveQuestion"
				@cancel="handleCancel"
			></ja-evaluation-question-create-new>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import EvaluationQuestionTable from '../evaluationQuestion/EvaluationQuestionTable.vue';
import EvaluationQuestionCreateNew from '../evaluationQuestion/EvaluationQuestionCreateNew.vue';
import LifeQuestionService from '@/services/cms/LifeQuestionService';
import AdminFacility from '@/mixins/AdminFacility';
import { lifestyleQuestionTypes } from '@/helpers/constants';

export default {
	components: {
		jaEvaluationQuestionTable: EvaluationQuestionTable,
		jaEvaluationQuestionCreateNew: EvaluationQuestionCreateNew,
		jaButton: Button
	},
	mixins: [AdminFacility],
	data() {
		return {
			showCreate: true,
			dataTableEvaluation: null,
			dataEdit: null
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getLifeQuestion();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		if (this.selectedFacilityId != null) {
			this.$store.commit('setLoading', true);
			this.getLifeQuestion();
		}
	},
	methods: {
		async getLifeQuestion() {
			const data = await LifeQuestionService.getAll(this.selectedFacilityId);
			this.dataTableEvaluation = data.sort((a, b) => {
				if (a.lifestyle_Question_Type_ID < b.lifestyle_Question_Type_ID) {
					return -1;
				} else if (a.lifestyle_Question_Type_ID > b.ifestyle_Question_Type_ID) {
					return 1;
				} else {
					if (a.lifestyle_Question_Type_ID == lifestyleQuestionTypes.PREPOST) {
						return a.questionOrder < b.questionOrder ? -1 : 1;
					} else {
						return a.lifestyle_Question_Format_ID <
							b.lifestyle_Question_Format_ID
							? -1
							: 1;
					}
				}
			});
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await LifeQuestionService.getById();
			data.lifestyleQuestion.facility_ID = this.selectedFacilityId;
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const data = await LifeQuestionService.getById(
				rowData.lifestyle_Question_ID
			);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await LifeQuestionService.deleteById(rowData.lifestyle_Question_ID);
			await this.getLifeQuestion();
		},
		async handleSaveQuestion(question) {
			this.$store.commit('setLoading', true);
			await LifeQuestionService.update(question);
			this.showCreate = true;
			await this.getLifeQuestion();
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getLifeQuestion();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
